<form autocomplete="off" (ngSubmit)="register()">
  <div class="form__header">
    <div class="form__header-title">{{ 'FORMS.sign_up_title' | translate }}</div>
    <!-- <div class="form__header-action">
      <a [routerLink]="[]" [queryParams]="authPage('register-company')" class="text--primary-light">{{ 'FORMS.create_company_account' | translate }} <i class="zmdi zmdi-chevron-right"></i></a>
    </div> -->
  </div>
  <div class="form__group">
    <app-ph-input
      [placeholder]="'FORMS.your_email' | translate"
      type="email"
      [validation]="'email'"
      name="email"
      [correctForm]="form"
    ></app-ph-input>
  </div>
  <div class="form__group-addon">
    <div class="form__group">
      <app-ph-input
        [placeholder]="'FORMS.your_password' | translate"
        [validation]="'password'"
        [errorDescription]="true"
        type="password"
        name="plain_password"
        [correctForm]="form"
      ></app-ph-input>
    </div>
    <div class="form__group">
      <app-ph-input
        [placeholder]="'FORMS.confirm_password' | translate"
        [validation]="'password'"
        [correctForm]="form"
        sameValue="plain_password"
        name="resetPassword"
        type="password"
      ></app-ph-input>
    </div>
  </div>
  <app-ph-input [validation]="'checkbox'" type="checkbox" name="confirm" [correctForm]="form">
    {{ 'AUTH.i_accept_the' | translate }}
    <a [routerLink]="['/' + RoutesPath.default.terms]" class="text--primary-light">{{
      'AUTH.terms_of_service' | translate
    }}</a>
  </app-ph-input>
  <div class="form__action">
    <button class="btn btn--primary btn--block btn--lg" [disabled]="loading">
      {{ 'AUTH.sign_up' | translate }}
    </button>
  </div>
</form>
<div class="card__body-separator">
  <span>{{ 'AUTH.or_sign_up_with_social' | translate }}</span>
</div>
<div class="btn__group">
  <button
    class="btn btn--outline btn--block btn--md btn--fill--white"
    (click)="socialSignUp('Facebook')"
  >
    <span class="btn__icon">
      <img src="assets/img/icons/fb.svg" [alt]="'AUTH.sign_up_with_facebook' | translate" />
    </span>
    <span class="btn__text text--fb">{{ 'AUTH.sign_up_with_facebook' | translate }}</span>
  </button>
</div>
<div class="btn__group">
  <google-signin-btn></google-signin-btn>
</div>
<div class="form__link form__link--sign-up">
  <span>{{ 'AUTH.already_have_an_account' | translate }}</span>
  <a
    [routerLink]="[]"
    [queryParams]="authPage('login')"
    class="text--primary-light text--decorated"
    >{{ 'AUTH.login_here' | translate }}</a
  >
</div>
